import { createLabeledMessages } from '@gef-ui/localization/messageUtils';

const fields = {
	documentId: 'ID dokumentu',
};

export default Object.assign({}, fields, createLabeledMessages(fields));
